import { render } from "./ModalSignOut.vue?vue&type=template&id=c4000f2c&scoped=true"
import script from "./ModalSignOut.vue?vue&type=script&lang=js"
export * from "./ModalSignOut.vue?vue&type=script&lang=js"

import "./ModalSignOut.vue?vue&type=style&index=0&id=c4000f2c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4000f2c"]])

export default __exports__